import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import Element from '@/models/element';
import { DeskLegsToSimpleSapElementMapper } from '../desk/deskLegsToSimpleSapElementMapper';

export class CtrLegsToSimpleSapELementMapper
    extends DeskLegsToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const code = this.toLegsType(element);
        const type = this.formatType(code, 6, 3);
        return [SimpleSapElement.LEG(type, '')];
    }
}
